import axios from 'axios';
import Cookies from "universal-cookie";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function getToken() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  
  // Note: Laravel Sanctum tokens are not JWTs, so we skip format validation
  // Basic XSS protection only
  if (token && (token.includes('<script') || token.includes('javascript:'))) {
    console.warn('Suspicious token content detected, removing token');
    return null;
  }
  
  return token;
}

/**
 * Get all research goals for a project
 */
export const getResearchGoals = async (projectUuid) => {
    try {
        const response = await axios.get(`${API_BASE}/project/${projectUuid}/research-goals`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Create a manual research goal
 */
export const createResearchGoal = async (projectUuid, goalData) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-goals`, goalData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Update a research goal
 */
export const updateResearchGoal = async (projectUuid, goalUuid, goalData) => {
    try {
        const response = await axios.put(`${API_BASE}/project/${projectUuid}/research-goals/${goalUuid}`, goalData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Delete a research goal
 */
export const deleteResearchGoal = async (projectUuid, goalUuid) => {
    try {
        const response = await axios.delete(`${API_BASE}/project/${projectUuid}/research-goals/${goalUuid}`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Generate AI suggestions for research goals
 */
export const generateGoalAISuggestions = async (projectUuid, scope, formResponses) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-goals/generate-ai`, {
            scope: scope,
            form_responses: formResponses
        }, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Accept and save one of the AI suggestions
 */
export const acceptGoalSuggestion = async (projectUuid, goalUuid, suggestionData) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-goals/${goalUuid}/accept-suggestion`, {
            selected_suggestion: suggestionData
        }, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Get form questions for goals based on scope
 */
export const getGoalFormQuestions = async (scope = 'academic') => {
    try {
        const response = await axios.get(`${API_BASE}/research-goals/form-questions/${scope}`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};